import React from 'react'
import PropTypes from 'prop-types'

// Render inline SVG
const SvgImage = ({ svg, alt, ...props }) => {
  // if supplied via a graphql query
  if (svg.publicURL) {
    return <img src={svg.publicURL} alt={alt} {...props} />
  }
  // if url or base64 encoded
  if (typeof svg === 'string') {
    return <img src={svg} alt={alt} {...props} />
  }
  const Component = svg
  return <Component {...props} />
}

SvgImage.propTypes = {
  svg: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
    PropTypes.elementType.isRequired,
  ]).isRequired,
  alt: PropTypes.string.isRequired,
}

SvgImage.defaultProps = {
  alt: '',
}

export default SvgImage
